const Home = () => {
  window.location.href = "https://getsmoodi.com";
  return (
    <></>
  );
};

export { Home };
